import { useTranslation } from "@impero-com/common/utils/i18n";

import { TestingActivityCurrentStep } from "api/generated/model";

export function useControlActivityStatusLabelMap(): Record<
    TestingActivityCurrentStep,
    string
> {
    const { t } = useTranslation();
    return {
        responsible: t("ControlTestingActivityView_Status_PendingResponsible"),
        firstReviewer: t("ControlTestingActivityView_Status_PendingReview"),
        secondReviewer: t("ControlTestingActivityView_Status_PendingReview"),
        completed: t("ControlTestingActivityView_Status_Completed"),
    };
}
